




























































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RetensiStore from "@/store/modules/RetensiAlihMediaStore";
import {
  ScanKandidatRow,
  ScanKandidatParams,
  RetensiBatch,
} from "@/types/RetensiAlihMedia";

@Component({ name: "RetensiStepBatchKandidat" })
export default class StepBatchKandidat extends Vue {
  @Prop({ type: Number, default: null }) sessionId!: number | null;
  @Prop({ type: Array, default: () => [] }) batches!: RetensiBatch[];

  store = RetensiStore;
  scanning = false;
  creating = false;
  selected: ScanKandidatRow[] = [];

  scan: ScanKandidatParams = {
    cutoff_date: this.fiveYearsAgo(),
    tahun_terlama: undefined,
    tahun_terbaru: undefined,
    limit: 1000,
    per_page: 100,
  };

  batchForm: Partial<RetensiBatch> = {
    tgl_mulai_alih_media: localISODate(),
    kriteria_inaktif: "RM dengan kunjungan terakhir ≥ 5 tahun lalu",
    kunjungan_tahun_terlama: new Date().getFullYear() - 10,
    kunjungan_tahun_terbaru: new Date().getFullYear() - 5,
    jumlah_berkas: 0,
    jumlah_nrm_unik: 0,
    lokasi_fisik_asal: "Ruang Filing Inaktif",
    lokasi_rme_tujuan: "DMS RSPS / Object Storage MinIO",
    klasifikasi_nilai_guna: "campuran",
  };

  kandidatHeaders = [
    { text: "No. RM", value: "no_rm" },
    { text: "Nama Pasien", value: "nama_pasien" },
    { text: "Tgl Lahir", value: "tgl_lahir" },
    { text: "Tgl Kunjungan Terakhir", value: "tgl_kunjungan_terakhir" },
  ];

  nilaiGunaOpts = [
    { value: "permanen", text: "Permanen (disimpan abadi)" },
    { value: "musnah_25thn", text: "Musnah setelah 25 tahun" },
    { value: "campuran", text: "Campuran" },
  ];

  fiveYearsAgo(): string {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 5);
    return localISODate(d);
  }

  formatDate(iso: string | null | undefined): string {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("id-ID");
  }

  @Watch("selected")
  onSelectedChange(rows: ScanKandidatRow[]) {
    this.batchForm.jumlah_berkas = rows.length;
    this.batchForm.jumlah_nrm_unik = new Set(rows.map((r) => r.no_rm)).size;
  }

  async doScan() {
    this.scanning = true;
    try {
      await this.store.scanKandidat(this.scan);
    } finally {
      this.scanning = false;
    }
  }

  async createBatch() {
    if (!this.sessionId) return;
    this.creating = true;
    try {
      await this.store.createBatch({
        sessionId: this.sessionId,
        data: this.batchForm,
      });
      this.$emit("refresh");
    } finally {
      this.creating = false;
    }
  }
}
